import { t } from 'i18next';
import { BaseController, BaseState } from '../../../common/controllers/BaseController';
import { WithRouterProps, withRouter } from '../../../common/higher-order-components/with-router';
import { UrlHelper } from '../../../common/utils/UrlHelper';
import { PATHS } from '../../../routing/routes';
import { FuzzerProfile } from '../models/FuzzerProfile';
import { TracerProfile } from '../models/TracerProfile';
import { OrganizationProfilesService } from '../services/OrganizationProfilesService';
import { FuzzerController } from './FuzzerController';
import { TracerController } from './TracerController';

type Props = WithRouterProps & {};

type State = BaseState & {};

class Controller extends BaseController<Props, State> {
  private readonly profilesService = new OrganizationProfilesService();

  private profileId: number;
  private profile: TracerProfile | FuzzerProfile | null;
  private canDuplicateProfile: boolean;

  constructor(props: Props, context: unknown) {
    super(props, context);

    ({ profileId: this.profileId } = this.parseNumericIds(['profileId']));
    this.profile = null;
    this.canDuplicateProfile = false;
  }

  componentDidMount() {
    super.componentDidMount();

    this.fetchData();
  }

  componentWillUnmount() {
    super.componentWillUnmount();

    this.profilesService.cancelAllRequests();
  }

  async fetchData() {
    try {
      this.profile = await this.profilesService.getProfile(this.profileId);
      this.canDuplicateProfile = await this.permissionsService.canCreateProfile();
      this.forceUpdate();
    } catch (e: unknown) {
      this.handleError(e, { invalidUrl: t('nonExistingProfile') });
    }
  }

  render() {
    const profileName = this.profile?.getName() ?? '';
    const breadcrumbPath = UrlHelper.generatePath(PATHS.PROFILE_DETAIL, { profileId: this.profileId.toString() });

    return this.renderBase(
      <>
        {this.profile instanceof TracerProfile && (
          <TracerController
            profile={this.profile}
            title={profileName}
            breadcrumbName={profileName}
            breadcrumbPath={breadcrumbPath}
            canDuplicate={this.canDuplicateProfile}
          />
        )}
        {this.profile instanceof FuzzerProfile && (
          <FuzzerController
            profile={this.profile}
            breadcrumbName={profileName}
            breadcrumbPath={breadcrumbPath}
            title={profileName}
            canDuplicate={this.canDuplicateProfile}
          />
        )}
      </>
    );
  }
}

export const ProfileDetailsController = withRouter(Controller);
